import React, { Component } from 'react';

export default class SettingScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    }
  }

  render() {
    return (
      <div className='settingScreen'>
        <p>This is the Setting</p>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/screens/SettingScreen.js